import PropTypes from "prop-types";
import { Card } from "@mui/material";

const AccentCard = ({ accentColor = "success.main", accentWidth = 4, sx = {}, children, ...props }) => {
  return (
    <Card
      {...props}
      sx={{
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: accentWidth,
          bgcolor: accentColor,
        },
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};

AccentCard.propTypes = {
  accentColor: PropTypes.string,
  accentWidth: PropTypes.number,
  sx: PropTypes.object,
  children: PropTypes.node,
};

export default AccentCard;
